import React from 'react';
import LoadingIcon from '../../../LoadingIcon';
import JsxHelper from '../../../../Helpers/JsxHelper';

export default class TimesheetUserListSelect extends React.Component {
  static defaultProps = {
    label: '',
    fieldName: '',
    onChange: () => {},
    selected: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selected: [],
    };
  }

  componentDidMount() {
    this.setState({
      selected: this.props.selected,
      timesheetUserName: this.props.selected.TimesheetUserUserName,
      loading: false,
    });
  }

  componentDidUpdate() {
    if (this.state.loading === true) {
      this.setState({ loading: false });
    }
  }

  renderInfo() {
    const cn2 = 'col-2  d-flex align-content-center flex-wrap justify-content-center';
    const cn2Header = `${cn2} font-weight-bold`;
    const cn2Body = `${cn2} border-top`;
    const userRows = [];
    //Header rows
    userRows.push(
      <div
        className={cn2Header}
        key='k1h'
      >
        UserId
      </div>
    );
    userRows.push(
      <div
        className={cn2Header}
        key='k2h'
      >
        UserName
      </div>
    );
    userRows.push(
      <div
        className={cn2Header}
        key='k3h'
      >
        Is Active?
      </div>
    );
    userRows.push(
      <div
        className={cn2Header}
        key='k4h'
      >
        Official Job Title
      </div>
    );
    userRows.push(
      <div
        className={cn2Header}
        key='k5h'
      >
        OfficeName
      </div>
    );
    userRows.push(
      <div
        className={cn2Header}
        key='k6h'
      >
        Timesheet
      </div>
    );

    //User rows
    this.state.selected.RelatedUsers.forEach((user, index) => {
      userRows.push(
        <div
          className={cn2Body}
          key={'k1' + index}
        >
          {user.userId}
        </div>
      );
      userRows.push(
        <div
          className={cn2Body}
          key={'k2' + index}
        >
          {user.userName}
        </div>
      );
      userRows.push(
        <div
          className={cn2Body + 'text-center'}
          key={'k3' + index}
        >
          {JsxHelper.YesNo(user.isActive)}
        </div>
      );
      userRows.push(
        <div
          className={cn2Body}
          key={'k4' + index}
        >
          {user.officialJobTitle}
        </div>
      );
      userRows.push(
        <div
          className={cn2Body}
          key={'k5' + index}
        >
          {user.officeName}
        </div>
      );
      userRows.push(
        <div
          className={cn2Body + ' pointer larger15 text-center'}
          onClick={() => {
            this.setState({
              timesheetUserId: user.userId,
              timesheetUserName: user.userName,
            });
            this.props.onChange(user.userName);
          }}
          data-tip='Click here to select the user as timesheetUser.'
          key={'k6' + index}
        >
          {JsxHelper.YesNo(user.userName === this.state.timesheetUserName)}
        </div>
      );
    });
    return (
      <div>
        <div className='container'>
          <div className='row align-items-stretch'>{userRows}</div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='w-100'>
        <div className='text-center hover rounded arial'>
          {this.props.label && (
            <label
              className='m-0 p-0 defaultfontsize '
              htmlFor={`htmlidfor${this.props.fieldName}`}
            >
              {this.props.label}
            </label>
          )}
          {this.state.loading ? (
            <LoadingIcon
              loading={true}
              className='h6'
            />
          ) : (
            this.renderInfo()
          )}
        </div>
      </div>
    );
  }
}
